import { createFileRoute } from "@tanstack/react-router";

import { FrameworksSection } from "../components/regulation/FrameworksSection";
import { RegulationPageShell } from "../components/regulation/RegulationPageShell";
import { useRegulationOrg } from "../components/regulation/useRegulationOrg";

/** The standards this organization has taken on, and how far along each is. */
function RegulationFrameworksRoute() {
  const { org: orgSegment } = Route.useParams();
  const { org } = useRegulationOrg();


  return (
    <RegulationPageShell
      title="Regimes"
      description="The rulebooks you are held to — add the ones that apply, and their controls become answerable. Your own frameworks organise them."
    >
      {(search) => (
        <FrameworksSection organizationId={org?.id ?? null} search={search} />
      )}
    </RegulationPageShell>
  );
}

export const Route = createFileRoute("/$org/compliance/regimes")({
  component: RegulationFrameworksRoute,
});
